Page userPage
	title = "Benutzer"
	showFor = [Admin]
	needsAuth = true

	DatabaseTable<User>	users = {"users"}

	show: string id = ""
		if app.user?.userType != Admin
			app.navigateTo homePage
			return
		html.setTitle title + app.titleSuffix
		await app.actions.subscribe sort:"created" expand:"good"
		await users.subscribe sort:"-created"

	hide
		app.actions.unsubscribe
		users.unsubscribe

	draw
		if app.user?.userType != Admin then return
		column gap:style.gapBetweenBoxes, margin:{top:32 bottom:32}
			row alignItems:center, justifyContent:spaceBetween, gap:16
				column
					div "Benutzer" color:secondaryColor fontSize:36
					div text:"{users.length} Nutzer und {app.actions.length} Aktionen", fontSize:15, color:lightGray
			users.items.orderByDescending.created
			for users as user
				drawUser user

	drawUser: User user
		let actions = app.actions.where.user == user.id
		app.box
			column gap:22
				row justifyContent:spaceBetween, alignItems:flexStart, gap:16
					column gap:6
						div text:user.name or user.email or "Unbenannter Nutzer", fontSize:24, fontWeight:bold, color:#2b3145
						div text:user.email, fontSize:14, color:secondaryColor
					div text:app.userTypeNames[user.userType] or "", fontSize:13, color:white, backgroundColor:secondaryColor, padding:{top:6 bottom:6 left:12 right:12}, borderRadius:20

				grid gridTemplateColumns:isMobile ? "1fr" : "1fr 1fr 1fr", gap:12
					column gap:8 backgroundColor:#f8fafc, borderRadius:12, padding:{top:12 bottom:12 left:14 right:14}
						drawDetail "Registriert", user.created ? user.created.dayMonthNameYearString : ""
						drawDetail "Zuletzt aktiv", actions.last?.created ? actions.last?.created.dayMonthNameYearString : ""
				
					column gap:8 backgroundColor:#f8fafc, borderRadius:12, padding:{top:12 bottom:12 left:14 right:14}
						drawDetail "Telefon", user.phoneNumber
						drawDetail "ID", user.id
					column gap:8 backgroundColor:#f8fafc, borderRadius:12, padding:{top:12 bottom:12 left:14 right:14}
						drawDetail "Adresse", "{user.streetAddress}<br>{user.zipCode} {user.city}<br>{user.country}".trim

				if user.claimedUserType and user.claimedUserType != user.userType
					drawApproval user

				div tag:"details", padding:{8 16 8 16}, marginBottom:0
					div tag:"summary", text:"{actions.length} Aktionen"
					if actions.length == 0
						div text:"Keine Aktionen vorhanden.", margin:{top:16}, color:lightGray
					else
						div overflowX:auto, margin:{top:16}
							grid gridTemplateColumns:"140px 1fr 220px 90px" gap:8, minWidth:680
								for actions as action
									div "{action.created.dayShortMonthNameString} {action.created.hourMinuteString} Uhr", fontSize:13, color:#40465a
									div getGoodName(action), fontSize:13, color:#40465a
									div app.actionTypeNames[action.actionType], fontSize:13, color:#2b3145
									div action.amount ? action.amount.currencyString : "", fontSize:13, color:#2b3145, textAlign:right

	drawDetail: string label, string value
		div
			div text:label, fontSize:12, color:#7a8195
			div text:value or "-", fontSize:15, color:#2b3145, wordBreak:"break-word"

	drawApproval: User user
		column gap:12 backgroundColor:style.lightColor, borderRadius:12, padding:{top:16 bottom:16 left:18 right:18}
			div "Freischaltung: {app.userTypeNames[user.claimedUserType] or user.claimedUserType}" fontSize:18 fontWeight:bold color:#2b3145
			if user.documents and user.documents.length > 0
				row gap:12 flexWrap:wrap
					for user.documents as document
						let url = "{backend.url}/api/files/users/{user.id}/{document}"
						if isImage document
							img src:url, width:140, height:100, objectFit:cover, borderRadius:10, cursor:pointer, onClick:Platform.openLink url
						else
							div document, color:primaryColor, textDecoration:underline, cursor:pointer, onClick:Platform.openLink url
			else
				div "Keine Dokumente hochgeladen.", color:lightGray
			app.button "Freischalten"
				onClick:
					await backend.post "/api/acceptUser", {userId:user.id}
					user.userType = user.claimedUserType
					refresh

	bool isImage: string file
		let name = file.toLowerCase
		return name.endsWith(".jpg") or name.endsWith(".jpeg") or name.endsWith(".png") or name.endsWith(".webp") or name.endsWith(".gif")

	string getGoodName: Action action
		let good = action.expand?.good
		if good then return "{good.Marke} {good.Modell}"
		if action.good then return action.good
		return ""
